import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'

const KINDS = [
  { id: 'bug', label: 'Bug', color: '#b4313c' },
  { id: 'idea', label: 'Idea', color: '#137050' },
  { id: 'question', label: 'Question', color: '#2a6a96' },
]

// "Send feedback": a small button in the sidebar footer next to Sign out (it used to sit fixed in the bottom-right corner,
// z-index 4000, on top of the floating AI button). The form opens as a centred window.
export default function FeedbackWidget({ page, style }) {
  const { config } = useAuth()
  const [open, setOpen] = useState(false)
  const [kind, setKind] = useState('bug')
  const [msg, setMsg] = useState('')
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)

  async function send() {
    const message = msg.trim()
    if (!message) return
    setSending(true)
    try {
      await supabase.from('feedback').insert({
        client_id: config?.id || null,
        actor_name: config?.crewName || config?.vessel_name || null,
        actor_type: config?.accountType === 'crew' ? 'crew' : 'vessel',
        page: page || null,
        kind,
        message,
        context: (typeof navigator !== 'undefined' ? navigator.userAgent : '')?.slice(0, 200) || null,
      })
      setSent(true)
      setMsg('')
      setTimeout(() => { setSent(false); setOpen(false); setKind('bug') }, 1600)
    } catch (e) { alert('Could not send feedback: ' + (e.message || 'unknown')) }
    finally { setSending(false) }
  }

  return (
    <>
      <button className="hc-fb-btn" onClick={() => setOpen(o => !o)} title="Send feedback" aria-label="Send feedback"
        style={{ background: 'transparent', border: '1px solid rgba(255,255,255,.12)', color: '#7E90AB', fontSize: 13, cursor: 'pointer',
          width: 28, height: 28, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, ...style }}>
        {'\u{1F4AC}'}
      </button>
      {open && (
        <div onClick={e => { if (e.target === e.currentTarget) setOpen(false) }} style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(0,0,0,.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <div className="hc-fb-panel" role="dialog" aria-label="Send feedback" style={{ position: 'relative', width: 340, maxWidth: '100%',
          background: 'var(--card, #11161e)', border: '0.5px solid var(--border, #1f2630)', borderRadius: 14, padding: 16,
          boxShadow: '0 20px 50px rgba(0,0,0,.5)', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <button onClick={() => setOpen(false)} aria-label="Close" style={{ position: 'absolute', top: 8, right: 10, background: 'none', border: 'none', color: 'var(--muted, #8a97a6)', fontSize: 18, cursor: 'pointer' }}>{'\u00d7'}</button>
          {sent ? (
            <div style={{ fontSize: 14, color: '#137050', fontWeight: 600, textAlign: 'center', padding: '12px 0' }}>Thanks — sent ✓</div>
          ) : (<>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text, #cdd6e0)' }}>Send feedback</div>
            <div style={{ display: 'flex', gap: 6 }}>
              {KINDS.map(k => (
                <button key={k.id} onClick={() => setKind(k.id)}
                  style={{ flex: 1, fontSize: 12, fontWeight: 600, padding: '6px 0', borderRadius: 7, cursor: 'pointer', fontFamily: 'inherit',
                    border: '0.5px solid ' + (kind === k.id ? k.color : 'var(--border, #1f2630)'),
                    background: kind === k.id ? k.color + '22' : 'var(--hull, #0b0f14)',
                    color: kind === k.id ? k.color : 'var(--muted, #8a97a6)' }}>{k.label}</button>
              ))}
            </div>
            <textarea autoFocus value={msg} onChange={e => setMsg(e.target.value)}
              placeholder={kind === 'bug' ? 'What went wrong? What were you doing?' : kind === 'idea' ? 'What would make this better?' : 'What are you unsure about?'}
              style={{ minHeight: 90, background: 'var(--bg, #0b0f14)', border: '0.5px solid var(--border, #1f2630)', borderRadius: 8,
                padding: '9px 11px', color: 'var(--text, #cdd6e0)', fontSize: 13, fontFamily: 'inherit', resize: 'vertical' }} />
            <div style={{ fontSize: 10.5, color: 'var(--muted, #8a97a6)' }}>Sent from: {page || 'app'}</div>
            <button onClick={send} disabled={sending || !msg.trim()}
              style={{ border: 'none', background: 'var(--gold2, #c9a84c)', color: '#fff', fontSize: 13, fontWeight: 700,
                padding: '10px', borderRadius: 8, cursor: 'pointer', opacity: (sending || !msg.trim()) ? .5 : 1 }}>
              {sending ? 'Sending\u2026' : 'Send'}
            </button>
          </>)}
        </div>
        </div>
      )}
    </>
  )
}
